const __WEBPACK_NAMESPACE_OBJECT__ = require("tiny-typed-emitter");